import { alpha } from '@mui/system';
import { CSSProperties } from 'react';
import { TableDetailsData } from '../../../../components';
import { themeObject } from '../../../../lib';

export const anchorPoint: 'top' | 'left' | 'bottom' | 'right' | undefined =
    'right';

export const jobDetailsDrawerStyle = {
    detailsDrawer: {
        width: '570px',
        '& .MuiPaper-root': {
            '& .drawer-content': {
                padding: '8px 0',
                scrollbarColor: 'initial',
                scrollbarWidth: 'initial',
            },
        },
    },
    accordionWrapper: {
        width: '510px',
    },
    missingReceiptDialog: {
        '& .MuiPaper-root': {
            height: '195px',
            width: '462px',
            borderRadius: '10px',
            boxShadow: `
             0px 6px 30px 5px ${alpha(themeObject.palette.grayScale[700], 0.12)},
             0px 16px 24px 2px ${alpha(themeObject.palette.grayScale[700], 0.14)},
             0px 8px 10px -5px ${alpha(themeObject.palette.grayScale[700], 0.2)},
             `,

            '#dialog-title-container': {
                minHeight: '68px',
            },
        },
        '& .MuiDialogContent-root': {
            padding: '16px 32px 16px 32px',
        },
        '& .MuiDialogContentText-root': {
            fontFamily: 'Red Hat Text',
            fontWeight: 400,
            fontSize: '20px',
            lineHeight: '26.46px',
            color: themeObject.palette.grayScale[800],
        },
    },
    missingReceiptModalButton: {
        transform: 'translateX(-82%) translateY(-40%)',
    },
    detailsContainer: {
        width: '510px',
    },
    nodeColorContainer: {
        margin: '7px 7px 0 8px',
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    titleStyle: {
        fontFamily: 'Source Code Pro',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '17.6px',
        letter: '0.5px',
        color: themeObject.palette.grayScale[700],
    },
    subheaderStyle: {
        fontFamily: 'Raleway',
        fontWeight: '500',
        fontSize: '24px',
        lineHeight: '28.18px',
        color: themeObject.palette.primary[700],
        fontVariantNumeric: 'lining-nums',
    },
    subheaderContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    subheaderInnerContainer: {
        display: 'inline-flex',
        alignItems: 'flex-end',
    },
    chipContainer: {
        paddingLeft: '5px',
    },
    buttonContainer: {
        paddingTop: '10px',
    },
};

export const ReceiptButtonStyle: CSSProperties = {
    position: 'relative',
    margin: 0,
    width: '135px',
    height: '100%',
};

export type DetailAccordion = {
    name: string;
    accordionAriaControls: string;
    accordionSumID: string;
    accordionHeader: string;
    error?: boolean;
    data?: any; // could be details, results, errors, or metadata
};
export const detailAccordions: DetailAccordion[] = [
    {
        name: 'panel1',
        accordionAriaControls: 'panel1-content',
        accordionSumID: 'panel1-header',
        accordionHeader: 'Job Details',
    },
    {
        name: 'panel2',
        accordionAriaControls: 'panel2-content',
        accordionSumID: 'panel2-header',
        accordionHeader: 'Results',
    },
    {
        name: 'panel3',
        accordionAriaControls: 'panel3-content',
        accordionSumID: 'panel3-header',
        accordionHeader: 'Metadata',
    },
    {
        name: 'panel4',
        accordionAriaControls: 'panel4-content',
        accordionSumID: 'panel4-header',
        accordionHeader: 'Errors',
        error: true,
    },
];

export interface JobManagerDetailsAccordionProps
    extends JobManagerAccordionHeaderProps,
        JobManagerAccordionDetailsProps {
    expanded: boolean;
    displayErrorIcon: boolean;
    onChange: (_: any, isExpanded: any) => void;
}

export interface JobManagerAccordionHeaderProps {
    accordionAriaControls: string;
    accordionSumID: string;
    accordionHeader: string;
}

export interface JobManagerAccordionDetailsProps {
    data?: TableDetailsData | string;
}

export const jobDetailsAccordionStyle = {
    emptyStateContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        mt: '7.5px',
        mb: '38.5px',
    },
    emptyStateText: {
        fontFamily: 'Raleway',
        fontWeight: '500',
        fontSize: ' 20px',
        lineHeight: '23.48px',
        color: themeObject.palette.primary[700],
    },
    errorHeaderContainer: {
        display: 'inline-flex',
    },
    errorIcon: {
        paddingLeft: '5px',
        height: '20px',
        width: '20px',
        color: themeObject.palette.error.light,
    },
    errorContainer: {
        margin: '0 0 10px 16px',
    },
    errorLabel: {
        fontFamily: 'Red Hat Text',
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '21.17px',
        letter: '0.15px',
        color: themeObject.palette.grayScale[800],
    },
    errorMessageContainer: {
        backgroundColor: themeObject.palette.grayScale[800],
        color: themeObject.palette.grayScale[100],
        fontFamily: 'Red Hat Text',
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '21.17px',
        letter: '0.15px',
        maxHeight: '300px',
        maxWidth: '700px',
        p: 1,
        overflowWrap: 'anywhere',
        overflow: 'auto',
        margin: '0 30px 27px 16px',
    },
    jsonErrorMessageContainer: {
        margin: '0 30px 0 16px',
    },
    jsonContainer: {
        height: '500px',
    },
    wrapperContainer: {
        width: '100%',
        height: '32px',
        alignContent: 'center',
        borderRadius: '4px 4px 0px 0px',
        backgroundColor: themeObject.palette.error[600],
    },
};

export const smartContractReceiptsQueryProps = {
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: false,
};
